/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { Typography, makeStyles, Grid } from '@material-ui/core';

import IconCloseRound from '../../assets/images/ic-close-round.svg';
import IconFaceAngryGrey from '../../assets/images/ic-face-angry-grey.svg';
import IconFaceFrowningGrey from '../../assets/images/ic-face-frowning-grey.svg';
import IconFaceNeutralGrey from '../../assets/images/ic-face-neutral-grey.svg';
import IconFaceSlightlySmillingGrey from '../../assets/images/ic-face-slightlysmilling-grey.svg';
import IconFaceSmilling from '../../assets/images/ic-face-smilling.svg';

const useStyles = makeStyles((theme) => {
  return {
    closeIcon: {
      cursor: 'pointer',
      height: '24px',
      position: 'absolute',
      right: '18px',
      top: '18px',
      width: 'auto',
      [theme.breakpoints.up('md')]: {
        right: '36px',
        top: '36px',
      },
    },
    container: {
      padding: '18px',
      position: 'relative',
      [theme.breakpoints.up('md')]: {
        padding: '36px',
        width: '450px',
      },
    },
    contentContainer: {
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: '265px',
      position: 'relative',
    },
    detail: {
      color: '#999999',
      fontSize: '12px',
      lineHeight: '18px',
      textAlign: 'center',
    },
    highlightedIcon: {
      height: 'auto',
      marginRight: '10px',
      width: '52px',
    },
    iconsContainer: {
      marginBottom: '17px',
    },
    smallIcon: {
      height: 'auto',
      marginBottom: '6px',
      marginRight: '10px',
      width: '20px',
    },
    smallIconLast: {
      marginRight: '0px !important',
    },
    subtitle: {
      color: '#172B4D',
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '24px',
      marginBottom: '20px',
      textAlign: 'center',
    },
    title: {
      color: '#2AAAE2',
      fontSize: '22px',
      fontWeight: '600',
      lineHeight: '24px',
      marginBottom: '2px',
      textAlign: 'center',
    },
  };
});

export default ({ onClose }) => {
  const classes = useStyles();

  const handleClose = () => {
    if (onClose && typeof onClose === 'function') onClose();
  };

  return (
    <div className={classes.container}>
      <div className={classes.contentContainer}>
        <Grid className={classes.iconsContainer} container justify="center" alignItems="flex-end">
          <Grid item>
            <img className={classes.smallIcon} src={IconFaceAngryGrey} alt="angry-face icon" />
          </Grid>
          <Grid item>
            <img className={classes.smallIcon} src={IconFaceFrowningGrey} alt="frowning-face icon" />
          </Grid>
          <Grid item>
            <img className={classes.highlightedIcon} src={IconFaceSmilling} alt="smilling-face icon" />
          </Grid>
          <Grid item>
            <img className={classes.smallIcon} src={IconFaceSlightlySmillingGrey} alt="slightly smile-face icon" />
          </Grid>
          <Grid item>
            <img className={`${classes.smallIcon} ${classes.smallIconLast}`} src={IconFaceNeutralGrey} alt="smilling-face icon" />
          </Grid>
        </Grid>
        <Typography className={classes.title}>Review successfully sent.</Typography>
        <Typography className={classes.subtitle}>Thank you for your time</Typography>
        <Typography className={classes.detail}>We have taken into account everything that you had to say about us in our review</Typography>
      </div>
      <img onClick={handleClose} className={classes.closeIcon} src={IconCloseRound} alt="close icon" />
    </div>
  );
};
